<div class="upp-floor-view">
    <upp-visible-control mode="fill">
        <upp-floor-render [orientation]="orientation" (OnKonva)="onKonvaFromRender($event)" (OnSelect)="onKonvaSelect($event)" (OnTransform)="onViewTransformFromRender($event)"></upp-floor-render>
    </upp-visible-control>
    <div *ngIf="showZoom" class="upp-floor-view__zoom" uppDataid="floor-view-zoom" aria-live="polite">{{ zoomLabel }}</div>
</div>
